export const environment = {
  production: true,
  cas_url: 'https://uatcas-api.mphtc.co',
  cas_ver: '/api/v1',
  mpi_url: 'https://uatmpi-api.mphtc.co',
  mpi_ver: '/api/v1',
  doctor_url: 'https://uatdoctor-api.mphtc.co',
  doctor_ver: '/api/v1',
  utilities_url: 'https://uatutilities-api.mphtc.co',
  utilities_ver: '/api/v1',
  forms_url: 'https://uatforms-api.mphtc.co',
  forms_ver: '/api/v1',
  schedule_url: 'https://uatschedule-api.mphtc.co',
  schedule_ver: '/api/v1',
  acs_connection_string: 'endpoint=https://mp-coms-001.communication.azure.com/;accesskey=Q6/Z4xfLTr2yHAsQ8jfep8B7Nr6lehygP+/J4tT8H76An3I/wbzAnLcwOSY+Sqe971CXisJtgm0lT8LHg1bWOg==',
  
  // pusher info,
  pusher_app_cluster: 'ap1',
  pusher_app_id: '1410527',
  pusher_app_key: 'b6bd23aa92eb2e767cc0',
  pusher_app_secret: 'b5b8d70cd9845185deb4',

  //recaptcha
  recaptch_site_key: '6LfiwUcgAAAAAJV2iWfBzZFIK5HqYVSy_PpXtary',
  recaptcha_secret_key: '6LfiwUcgAAAAAEte6ZLGKjbepfQ3-iJYC6iL7qHc',

  // telemedicine credentials
  mwell_basic_api: 'https://apimgmt-mwelltelemed-hippo-001.azure-api.net/api/v1',
  mwell_telemend_url: 'https://apimgmt-mwelltelemed-hippo-001.azure-api.net/api/v1/web/doctors_onboarding',
  mwell_telemend_subscription_key: 'a22488b80fd3403293de4b7f810a22c6',
  mwell_telemend_key: 'mwellmd',
  mwell_telemend_secret: 'erHnF8YU2Lbt79tTBBvR',
  mwell_telemend_renew_time: 50,

  //mWell Basic
  mwell_basic: '',
  mwellmd_emr: '',
  adb2c_auth_url: '',

  adb2c_logout_url: '',
  pe_dev_api_url: '',

  top_dev_api_url: '',
  top_dev_x_api_key: '',

};
  
